export default __webpack_public_path__ + "static/empowerment-cc0739c70be046c9bdbfe01961439d31.webp";